import {Component, HostBinding,OnInit} from '@angular/core';
import {select} from '@angular-redux/store';
import {Observable} from 'rxjs';
import {ThemeOptions} from '../../../theme-options';
import { AuthService } from '../../../Pages/authentication/auth.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit{
  type:any;
  flag:boolean=false;
  ProfileImage: any;
  constructor(
    public globals: ThemeOptions,
    private authService: AuthService
    ) {}

  ngOnInit() {
    this.type = localStorage.getItem('scope')
    if(this.type==2||this.type==3){
      this.flag=true;
    }
  }

  @HostBinding('class.isActive')
  get isActiveAsGetter() {
    return this.isActive;
  }

  isActive: boolean;
  @select('config') public config$: Observable<any>;

  toggleSidebarMobile() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
  }

  toggleHeaderMobile() {
    this.globals.toggleHeaderMobile = !this.globals.toggleHeaderMobile;
  }

  logout() {
    this.authService.logout();
  }

}
